<div class="top-bar">
  <div class="tabs">
    <div [class.active]="currentTab === 'EDITOR'" (click)="switchTab('EDITOR')" class="clickable tab" translate="CALLS.EDITOR"></div>
    @if (call.isOutlineReady) {
      <div [class.active]="currentTab === 'OUTLINE'" (click)="switchTab('OUTLINE')" class="clickable tab" translate="CALLS.OUTLINE"></div>
    }
  </div>
  @if (call.isPostProcessingComplete) {
    <div class="buttons">
      @if (currentTab === 'OUTLINE') {
        @if (showExpandAll) {
          <button mat-icon-button (click)="expandAll()">
            <mat-icon fontSet="material-symbols-outlined">expand_all</mat-icon>
          </button>
        } @else {
          <button mat-icon-button (click)="collapseAll()">
            <mat-icon fontSet="material-symbols-outlined">collapse_all</mat-icon>
          </button>
        }
      }
      @if (canUserEdit && currentTab === 'EDITOR') {
        <button mat-icon-button (click)="showRevisionHistory()" [matTooltip]="'CALLS.SHOW_REVISION_HISTORY' | translate" [disabled]="isEditorLockedByOtherUser">
          <mat-icon>timeline</mat-icon>
        </button>
        <button mat-icon-button (click)="resetEditor()" [matTooltip]="'CALLS.RESET_EDITOR' | translate" [disabled]="isEditorLockedByOtherUser">
          <mat-icon>history</mat-icon>
        </button>
      }
      @if (currentTab === 'EDITOR' && hasCitations) {
        <button
          mat-icon-button
          (click)="settingsOpen = !settingsOpen"
          [matTooltip]="'EDITOR.SETTINGS.TITLE' | translate"
          cdkOverlayOrigin
          #settingsTrigger="cdkOverlayOrigin"
        >
          <mat-icon>settings</mat-icon>
        </button>
      }
      @if (currentUser$ | async; as user) {
        @if (currentTab !== 'OUTLINE' || user.organization.allowOutlineDownload) {
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>download</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="exportDocument('pdf')">PDF</button>
            <button mat-menu-item (click)="exportDocument('docx')">DOCX</button>
          </mat-menu>
        }
      }
    </div>
  }
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'settings-backdrop'"
  (backdropClick)="settingsOpen = false"
  [cdkConnectedOverlayOrigin]="settingsTrigger"
  [cdkConnectedOverlayOpen]="settingsOpen"
  [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }]"
>
  <div class="settings-overlay">
    <div class="settings-header">
      <span class="settings-title">{{ 'EDITOR.SETTINGS.TITLE' | translate }}</span>
      <button mat-icon-button class="close-button" (click)="settingsOpen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="settings-item">
      <mat-slide-toggle [(ngModel)]="showCitations" labelPosition="after">
        {{ 'EDITOR.SETTINGS.SHOW_CITATIONS' | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</ng-template>

<div class="content">
  @if (currentTab === 'EDITOR') {
    <app-editor
      [call]="call"
      [canUserEdit]="canUserEdit"
      [canUserComment]="canUserComment"
      (isLocked)="isEditorLockedByOtherUser = $event"
      (openAgendaUpload)="openAgendaUpload.emit()"
      (openDocument)="openDocument.emit($event)"
      (openMeeting)="openMeeting.emit()"
    ></app-editor>
  } @else if (currentTab === 'OUTLINE') {
    <app-outline [call]="call"></app-outline>
  }
</div>
